<template>
<div>
  <h1> A webpage is here</h1>
  <div style="height:1500px;background-color:green"></div>
      <widget
        survey_id="183696c0-e89f-46ca-b595-5c89425c68d2"
        email="dssdfsd@doe.com"
        name="Jane Q. Doe"
        user_id="apple123"
      />
</div>      
</template>

<script>
import Widget from "@/Widget.vue";

export default {
    components: { Widget }
}
</script>

  <style>
    html {
      font-size: 10px;
      font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
      color: green;
      background: white;
    }
  
  </style>

